<script>
import {createMockPackage, fetchSummary, getMatchedSKU} from "@/api/system/customer";
import {copyToClipboard} from "@/utils/copyClick";
import getLodop from "@/utils/lodop";

export default {
  name: 'Task',
  inject: ["$page"],
  props: {
    batchNumber: {
      type: Object
    }
  },
  data() {
    return {
      skuMap: null,
      skuBarCode: '',
      tableData: [],
      batchSummary: {
        elements: [], count: 0, skuCount: 0, valuesCount: 0, weightCount: 0
      },
      summary: {
        skuCount: 0, declaration: '0.0000', totalWeight: '0.00'
      },
      fields: [
        {title: '商品名称', key: 'title', align: 'center', width: 190},
        {title: '条形码', key: 'skuCode', align: 'center', width: 170},
        {
          title: '单件申报价值', key: 'values', align: 'center', width: 140, render: (h, {column, index}) => {
            return h('Input', {
              props: {
                value: this.tableData[index]['values'],
                className: 'textCenter'
              },
              on: {
                input: (v) => {
                  if (this.checkParams(v, false, '单件申报价值') === false) {
                    return false
                  }
                  // 刷新统计
                  this.tableData[index]['values'] = v;
                  this.refreshSummary()
                }
              }
            })
          }
        },
        {
          title: '数量', key: 'count', align: 'center', width: 100, render: (h, {column, index}) => {
            return h('Input', {
              props: {
                value: this.tableData[index]['count'],
              },
              on: {
                input: (v) => {
                  if (this.checkParams(v, true, '数量') === false) {
                    return false
                  }
                  // 刷新统计
                  this.tableData[index]['count'] = v;
                  this.refreshSummary()
                }
              }
            })
          }
        },
        {
          title: '单件重量', key: 'weight', align: 'center', render: (h, {column, index}) => {
            return h('Input', {
              props: {
                value: this.tableData[index]['weight'],
              },
              on: {
                input: (v) => {
                  if (this.checkParams(v, false, '单件重量') === false) {
                    return false
                  }
                  // 刷新统计
                  this.tableData[index]['weight'] = v;
                  this.refreshSummary()
                }
              }
            })
          }
        },
        {
          title: '操作', key: 'skuId', align: 'center', render: (h, {column, index}) => {
            return h('i-button', {
              props: {
                type: 'error'
              },
              on: {
                click : ({column, index}) => {
                  console.clear()
                  this.tableData.splice(index, 1)
                  this.refreshSummary()
                }
              }
            }, '删除')
          }
        },
      ]
    }
  },
  methods: {
    checkParams(v, isIntSymbol, prefix) {
      if (/^[-+]?(\d+(\.\d*)?|\.\d+)([eE][-+]?\d+)?$/.test(v) === false) {
        this.$Message.error(`${prefix}只能接受数字类型`)
        return false
      }
      let expectValue = parseFloat(v)
      if (expectValue <= 0) {
        this.$Message.error(`${prefix}必须为大于0的数字`)
        return false
      }
      if (isIntSymbol && v.indexOf('.') !== -1) {
        this.$Message.error(`${prefix}只能接受大于0整数类型`)
        return false
      }
      return true
    },
    filterBarCode() {
      if (this.skuBarCode.toLowerCase() === 'createorder') {
        // 创建小包订单
        this.$Spin.show()
        createMockPackage({goods: this.tableData, batchNumber: this.batchNumber.params.batch_number}).then(res => {
          this.$Spin.hide()
          if (res.data.status) {
            this.skuBarCode = ''
            this.tableData = []
            this.summary = {skuCount: 0, declaration: '0.0000', totalWeight: '0.00'}
            this.$Message.success(res.data.msg)
            this.fetchBatchSummary(this.batchNumber.params.batch_number)
            let printerIndex = window.localStorage.getItem('DefaultPrinterIndex')
            if (!printerIndex) {
              printerIndex = 0
            }
            // 打印面单
            let lodop = getLodop(this)
            LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
            LODOP.SET_PRINTER_INDEX(printerIndex);
            LODOP.SET_PRINT_PAGESIZE(1, 1000, 1500, ""); //规定纸张大小；使用100*150纸
            LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', res.data.payload);
            LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Width");
            LODOP.SET_PRINT_MODE("PRINT_DUPLEX", 1);
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1);
            LODOP.PRINT(); //打印预览
          } else {
            this.$Message.error(res.data.msg)
          }
        }).catch(e => {
          this.$Spin.hide()
          this.$Message.error(res.data.msg)
        })
      } else {
        let matched = this.skuMap.filter(v => v.bar_code.toLowerCase() === this.skuBarCode.toLowerCase())
        if (matched.length === 0) {
          this.$Message.error(`${this.skuBarCode}不属于当前批次允许客户的SKU`)
          this.skuBarCode = ''
        } else {
          // 压入的到SKU记录中
          let symbol = this.tableData.findIndex(v => v.skuCode.toLowerCase() === this.skuBarCode.toLowerCase())
          if (symbol === -1) {
            // 直接压入
            this.tableData.push({
              skuCode: this.skuBarCode,
              count: 1,
              values: parseFloat(matched[0]['declaration_amount']).toFixed(4),
              weight: parseFloat(matched[0]['weight']).toFixed(2),
              title: matched[0]['sku_name'],
              hsCode: matched[0]['hs_code'],
              name: matched[0]['sku_title'],
            })
          } else {
            this.tableData[symbol].count += 1
          }
          this.skuBarCode = ''
          this.refreshSummary()
        }
      }
    },
    refreshSummary() {
      let totalSize = 0,
        totalValues = 0,
        totalWeight = 0
      for (const element of this.tableData) {
        totalSize += parseInt(element.count)
        totalValues += totalValues + parseFloat(element.values) * parseInt(element.count)
        totalWeight += totalWeight + parseFloat(element.weight) * parseInt(element.count)
      }
      this.summary = {
        skuCount: totalSize, declaration: totalValues.toFixed(4), totalWeight: totalWeight.toFixed(2)
      }
    },
    fetchBatchSummary(key) {
      this.$Spin.show()
      fetchSummary(key).then(res => {
        this.$Spin.hide()
        this.batchSummary = res.data.payload
      })
    },
    copyShipments() {
      copyToClipboard(this.batchSummary.elements.map(v => v.shipmentNumber).join("\r\n"), this)
    },
    copyElement(v) {
      copyToClipboard(v, this)
    }
  },
  mounted() {
    this.$Spin.show()
    // 加载SKU信息
    getMatchedSKU(this.batchNumber.params.batch_number).then(res => {
      this.skuMap = res.data.payload
      this.$refs.scanner.focus()
      this.fetchBatchSummary(this.batchNumber.params.batch_number)
    }).catch(e => {
      this.$Message.error(e.message)
      this.$Spin.hide()
    })
  }
}
</script>

<template>
  <div>
    <Row :gutter="20">
      <Col span="12">
        <Form :label-width="100" @submit.native.prevent>
          <FormItem label="当前批次号码">
            <Input v-model="batchNumber.params.batch_number" :readonly="true"></Input>
          </FormItem>
          <FormItem label="SKU编码">
            <Input ref="scanner" v-model="skuBarCode" placeholder="请扫描SKU编码"
                   @keydown.enter.native="filterBarCode"></Input>
          </FormItem>
        </Form>
      </Col>
      <Col span="12">
        <Row :gutter="16">
          <Col span="8">
            <Card>
              <p slot="title">SKU数量</p>
              <div class="text-center">{{ summary.skuCount }} 个</div>
            </Card>
          </Col>
          <Col span="8">
            <Card>
              <p slot="title">订单价值</p>
              <div class="text-center">{{ summary.declaration }} USD</div>
            </Card>
          </Col>
          <Col span="8">
            <Card>
              <p slot="title">订单重量</p>
              <div class="text-center">{{ summary.totalWeight }} Kg</div>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>

    <hr/>
    <Table ref="selection" :columns="fields" :data="tableData" :max-height="240" border></Table>
    <div style="height: 10px;"></div>
    <Card>
      <p slot="title">
        批次已创建订单列表
      </p>
      <div slot="extra">
        <ButtonGroup class="small-tips">
          <Button size="small" type="primary">订单数量</Button>
          <Button size="small">{{batchSummary.count}}</Button>
        </ButtonGroup>

        <ButtonGroup class="small-tips">
          <Button size="small" type="primary">SKU数量</Button>
          <Button size="small">{{batchSummary.skuCount}}</Button>
        </ButtonGroup>

        <ButtonGroup class="small-tips">
          <Button size="small" type="primary">批次价值</Button>
          <Button size="small">{{batchSummary.valuesCount.toFixed(4)}} SAR</Button>
        </ButtonGroup>

        <ButtonGroup class="small-tips">
          <Button size="small" type="primary">批次重量</Button>
          <Button size="small">{{batchSummary.weightCount.toFixed(2)}} KG</Button>
        </ButtonGroup>

        <Button size="small" type="error" @click="copyShipments">复制批次单号</Button>
      </div>
      <div style="height: 200px; overflow-y: scroll; overflow-x: hidden; padding-left: 5px;">
        <Row :gutter="4">
          <Col v-for="(item, k) in batchSummary.elements" span="6" class="spin">
            <ButtonGroup>
              <Button style="width: 40px;" @click="copyElement(item.shipmentNumber)">{{ item.index }}</Button>
              <Button type="primary" >{{ item.shipmentNumber }}</Button>
            </ButtonGroup>
          </Col>
        </Row>
      </div>
    </Card>
  </div>
</template>

<style scoped>
.tips {
  padding: 5px 10px;
  margin-bottom: 5px;
}

.text-center {
  text-align: center;
}

.spin {
  margin-bottom: 5px;
}

.small-tips {
  margin-right: 5px;
}
</style>
